import {getHiddenDimensions, getMoveCount, scrollElement} from "./Util";
import {EN} from '../helpers/GlobalsHelper';
import $ from 'jquery';
import throttle from 'lodash/throttle';
/**
 * Productcarousel Class
 *
 * @param root
 * @param settings
 * @constructor
 */
class Carousel {

	static _defaults = {
		selectors: {
			root: '.mdl_carousel',
			wrapper: '.mdl_carousel__carousel-list-wrapper',
			scroller: '.mdl_carousel__carousel-list',
			inner: '.mdl_carousel__carousel-list_inner',
			items: '.mdl_carousel__carousel-item',
			controls: {
				root: '.mdl_carouselcontrols',
				prev : '.mdl_carouselcontrols__control--prev',
				next : '.mdl_carouselcontrols__control--next',
				prevTrigger: '.mdl_carouselcontrols__control-trigger',
				nextTrigger: '.mdl_carouselcontrols__control-trigger'
			},
		},
		settings: {
			controlsType: 'default',
			centerControlsTo: false,
			orientationVertical: false,
			showControlsOnTouch: false,
			scrollNative: true,
			scrollToSelected: false
		}
	};

	constructor( carouselEl, selectors = {}, settings = {} ) {
		this.selectors = Object.assign( {}, Carousel._defaults.selectors, selectors );
		this.settings = Object.assign( {}, Carousel._defaults.settings, settings );

		// Elements
		this.root = carouselEl;
		this.wrapper = this.root.querySelector( this.selectors.wrapper );
		this.scroller = this.root.querySelector( this.selectors.scroller );
		this.inner = this.root.querySelector( this.selectors.inner );
		this.items = this.root.getElementsByClassName( this.selectors.items.slice( 1 ) );
		this.controlsRoot = this.root.querySelector( this.selectors.controls.root );
		this.controlsPrev = this.controlsRoot.querySelector( this.selectors.controls.prev );
		this.controlsNext = this.controlsRoot.querySelector( this.selectors.controls.next );
		this.linkedSlider = false;

		if( this.settings.controlsType === 'default' ) {
			this.controlsPrevTrigger = this.controlsPrev.querySelector( this.selectors.controls.prevTrigger );
			this.controlsNextTrigger = this.controlsNext.querySelector( this.selectors.controls.nextTrigger );
		} else {
			this.controlsPrevTrigger = this.controlsPrev;
			this.controlsNextTrigger = this.controlsNext;
		}

		// Settings
		this.settings.centerControlsTo = ( this.root.classList.contains( 'mdl_carousel--variation-blog' ) || this.root.classList.contains( 'mdl_carousel--variation-voucher' ) ? '.mdl_image' : false ) || this.settings.centerControlsTo;

		if( this.settings.scrollToSelected ) {
			const selectedItem = this.root.querySelector( this.selectors.selectedItem );

			if( selectedItem ) {
				this.scroller.scroll( { left: selectedItem.previousElementSibling ? selectedItem.previousElementSibling.offsetLeft : selectedItem.offsetLeft } );
			}
		}

		this.scroller.addEventListener( 'scroll', throttle( () => this.handleScrollResize() ) );
		window.addEventListener( 'resize', throttle( () => this.reinitialize() ) );

		this.root.addEventListener( 'carouselUpdateItems.sl', () => {
			this.reinitialize();
		} );

		if( this.activeControls() ) {
			this.controlsRoot.classList.add( 'is-active' );

			this.controlsPrevTrigger.addEventListener( 'click', this.handleNavigation );
			this.controlsNextTrigger.addEventListener( 'click', this.handleNavigation );

			if( this.settings.centerControlsTo ) {
				this.centerCarouselControlPositionTo();
				window.addEventListener( 'resize', throttle( () => this.centerCarouselControlPositionTo() ) );
			}
		}

		if( this.root.id ) {
			this.linkedSlider = document.querySelector( '[data-sync="' + this.root.id + '"]' );

			if( this.linkedSlider ) {
				this.root.addEventListener( 'syncThumbs', this.move );
				this.root.addEventListener( 'click', ( evt ) => {
					const clickedItemEl = evt.target.closest( this.selectors.items );
					if ( clickedItemEl && clickedItemEl.dataset.slideIndex ) {
						evt.preventDefault();
						const slideIndex = clickedItemEl.dataset.slideIndex;

						const itemsArray = this.getItemsArray();
						itemsArray.forEach( ( item ) => item.classList.remove( 'active' ) );
						itemsArray[slideIndex].classList.add( 'active' );

						this.linkedSlider.dispatchEvent( new CustomEvent( 'syncThumbs', { detail: slideIndex } ) );
					}
				} );
			}
		}

		this.root.classList.add( 'is-initialized' );
	}

	reinitialize = () => {
		this.setScrollerDimensions();
		this.handleScrollResize();
	}

	handleScrollResize = () => {
		if ( ! this.scroller.isConnected )  {
			return;
		}

		this.scroller.classList.toggle( 'is-startingposition', this.isOnStartPosition() );
		this.scroller.classList.toggle( 'is-endingposition', this.isOnEndPosition() );

		if( !this.isScrollable() ) {
			this.controlsPrev.classList.add( 'is-disabled' );
			this.controlsNext.classList.add( 'is-disabled' );
			this.scroller.classList.remove( 'is-scrollable' );
		} else {
			this.scroller.classList.add( 'is-scrollable' );
			this.setScrollerDimensions();
			this.getActualScrollPosition() <= 0 ? this.controlsPrev.classList.add( 'is-disabled' ) : this.controlsPrev.classList.remove( 'is-disabled' );
			this.getActualScrollPosition() + 1 >= this.getMaxScrollPosition() ? this.controlsNext.classList.add( 'is-disabled' ) : this.controlsNext.classList.remove( 'is-disabled' );
		}
	}

	handleNavigation = e => {
		const control = e.target;
		const direction = control.closest( this.selectors.controls.prev ) && 'prev' || control.closest( this.selectors.controls.next ) && 'next';
		const isDisabled = control.classList.contains( 'is-disabled' );
		if( isDisabled ) return;
		this.move( direction );
	}

	getItemsArray = () => {
		return Array.from( this.items ).filter( item => !item.classList.contains( 'en_hidden' ) );
	}

	move = ( direction = 'next' ) => {
		let scrolltoitemIndex = false;
		let itemsArray = this.getItemsArray();

		if( typeof direction === 'object' && 'detail' in direction ) {
			scrolltoitemIndex = direction.detail.slideIndex;
			direction = direction.detail.direction;

			if( itemsArray[scrolltoitemIndex] ) {
				itemsArray.forEach( ( item ) => item.classList.remove( 'active' ) );
				itemsArray[scrolltoitemIndex].classList.add( 'active' );

				if( direction === 'next' ) scrolltoitemIndex++;
				if( direction === 'prev' ) scrolltoitemIndex--;
			}
		}

		const snapPoint = direction === 'next' ? ( this.settings.orientationVertical ? this.wrapper.clientHeight : this.wrapper.clientWidth ) : 0;
		const snapPointOffset = this.getActualScrollPosition() + snapPoint;
		const epsilon = 1; // Tolerance concerning

		if( scrolltoitemIndex === false ) {
			if( direction === 'prev' ) {
				itemsArray = itemsArray.toReversed();
			}

			let edgeitemIndex;
			for ( edgeitemIndex = 0; edgeitemIndex < itemsArray.length; edgeitemIndex++ ) {
				const edgeitemOffset = ( this.settings.orientationVertical ? itemsArray[edgeitemIndex].offsetTop : itemsArray[edgeitemIndex].offsetLeft );
				const edgeItemBoundingClientRect = itemsArray[edgeitemIndex].getBoundingClientRect();
				const edgeitemSize = ( this.settings.orientationVertical ? edgeItemBoundingClientRect.height : edgeItemBoundingClientRect.width ) - this.getItemPaddingCalculation( itemsArray[edgeitemIndex] );

				if(
					direction === 'next' && edgeitemOffset + edgeitemSize > snapPointOffset + epsilon ||
					direction === 'prev' && edgeitemOffset < snapPointOffset - epsilon ) {
					break;
				}
			}

			const slideNum= Math.min(
				Math.floor(
					this.settings.orientationVertical ? this.wrapper.clientHeight : this.wrapper.clientWidth /
					this.settings.orientationVertical ? itemsArray[edgeitemIndex].offsetWidth : itemsArray[edgeitemIndex].offsetHeight
				) - 1,
				getMoveCount( this.root ) );
			scrolltoitemIndex = edgeitemIndex + slideNum;
		}

		let scrolltolastitem = false;
		if( scrolltoitemIndex >= itemsArray.length ) {
			scrolltoitemIndex = itemsArray.length - 1;
			scrolltolastitem = true;
		} else if( scrolltoitemIndex <= 0 ) {
			scrolltoitemIndex = 0;
		}

		const scrollToItemOffset = ( this.settings.orientationVertical ? itemsArray[scrolltoitemIndex].offsetTop : itemsArray[scrolltoitemIndex].offsetLeft );
		const scrollToItemBoundingClientRect = itemsArray[scrolltoitemIndex].getBoundingClientRect();
		const scrollToItemSize = ( this.settings.orientationVertical ? scrollToItemBoundingClientRect.height : scrollToItemBoundingClientRect.width ) - this.getItemPaddingCalculation( itemsArray[scrolltoitemIndex] );
		const amount = scrollToItemOffset - snapPoint + ( direction === 'next' ? scrollToItemSize + ( scrolltolastitem ? 10 : 0 ) : 0 );

		if( this.settings.scrollNative ) {
			scrollElement( this.scroller, amount, this.settings.orientationVertical );
		} else {
			$( this.scroller ).animate( {
				...( this.settings.orientationVertical && { scrollTop: amount } ),
				...( !this.settings.orientationVertical && { scrollLeft: amount } ),
			}, 300 );
		}
	}

	centerCarouselControlPositionTo = () => {
		if ( ! this.root.isConnected )  {
			return;
		}
		const image = this.root.querySelector( this.settings.centerControlsTo );
		const imageDimensions = getHiddenDimensions( image );
		const topPosition = imageDimensions.innerHeight / 2 + imageDimensions.offsetTop;

		this.controlsPrevTrigger.style.top = topPosition + 'px';
		this.controlsNextTrigger.style.top = topPosition + 'px';
	}
	setScrollerDimensions = () => {
		if ( ! this.scroller.isConnected )  {
			return;
		}
		this.scrollerDimensions = getHiddenDimensions( this.scroller );
	}

	getItemPaddingCalculation = ( item ) => {
		if( this.inner && parseFloat( window.getComputedStyle( this.inner, null ).getPropertyValue( this.settings.orientationVertical ? 'margin-top' : 'margin-left' ) ) === 0 ) {
			return 0;
		}

		item = window.getComputedStyle( item, null );
		return parseFloat( item.getPropertyValue( this.settings.orientationVertical ? 'padding-top' : 'padding-left' ) ) + parseFloat( item.getPropertyValue( this.settings.orientationVertical ? 'padding-bottom' : 'padding-right' ) );
	}

	getActualScrollPosition() {
		return this.settings.orientationVertical ? this.scroller.scrollTop: this.scroller.scrollLeft;
	}

	getMaxScrollPosition() {
		return this.settings.orientationVertical ? this.scrollerDimensions.scrollHeight - this.scrollerDimensions.innerHeight : this.scrollerDimensions.scrollWidth - this.scrollerDimensions.innerWidth;
	}

	isScrollable() {
		return this.getMaxScrollPosition() !== 0;
	}

	isOnStartPosition() {
		return this.getActualScrollPosition() === 0;
	}

	isOnEndPosition() {
		return this.getActualScrollPosition() + 1 >= this.getMaxScrollPosition();
	}

	activeControls() {
		return !EN.Supports.touch() || this.settings.showControlsOnTouch;
	}
}

const initCarousel = function( elem, selectors = {}, settings = {}, scopeEl = document ) {
	let carouselEls;

	if ( elem instanceof NodeList ) {
		carouselEls = elem;
	} else if ( elem instanceof Element ) {
		carouselEls = [ elem ];
	} else {
		carouselEls = scopeEl.querySelectorAll( elem );
	}

	if ( carouselEls ) {
		carouselEls.forEach( carouselEl => {
			//Check for 8Select productcarousels
			if ( carouselEl.classList.contains( '-eightselect-widget-container' ) ) {
				return;
			}

			carouselEl.SL_Carousel ??= new Carousel( carouselEl, selectors, settings );
			carouselEl.SL_Carousel.reinitialize();
		} );
	}
}

const initMainMenuCarousel = function( scopeEl = document ) {
	initCarousel(
		'.mdl_mainmenu',
		{
			wrapper: '.mdl_mainmenu__root',
			scroller: '.mdl_mainmenu__root-inner',
			inner: '.mdl_mainmenu__root-ul',
			items: '.mdl_mainmenu__root-item',
			controls: {
				root: '.mdl_mainmenu__controls',
				prev: '.mdl_mainmenu__control-prev',
				next: '.mdl_mainmenu__control-next',
			}
		},
		{
			controlsType: 'simple',
		},
		scopeEl
	);
}

const initProductCarousel = function( scopeEl = document ) {
	initCarousel(
		'.mdl_productcarousel',
		{
			wrapper: '.productcarousel__inner',
			scroller: '.productcarousel__list',
			inner: '.productcarousel__list_inner',
			items: '.mdl_productcarousel_item',
		},
		{

		},
		scopeEl
	);
}

const initBrandCarousel = function( scopeEl = document ) {
	initCarousel(
		'.en_mdl_brandslider',
		{
			wrapper: '.en_mdl_brandslider__list_wrapper',
			scroller: '.en_mdl_brandslider__list',
			inner: '.en_mdl_brandslider__list_inner',
			items: '.en_mdl_brandslider__item',
			controls: {
				root: '.en_mdl_brandslider__controls',
				prev: '.en_mdl_brandslider__prev',
				next: '.en_mdl_brandslider__next',
			}
		},
		{
			controlsType: 'simple',
		},
		scopeEl
	);
}

const initLinklistCarousel = function( scopeEl = document ) {
	initCarousel(
		'.en_mdl_linklist__carousel.en_mdl_linklist__carousel--chip',
		{
			wrapper: '.en_mdl_linklist__wrapper',
			scroller: '.en_mdl_linklist__wrapper-inner',
			inner: 'en_mdl_linklist__inner',
			items: '.en_list__item',
			controls: {
				root: '.en_mdl_linklist__controls',
				prev: '.en_mdl_linklist__prev',
				next: '.en_mdl_linklist__next',
			}
		},
		{
			controlsType: 'simple',
		},
		scopeEl
	);

	initCarousel(
		'.en_mdl_linklist__carousel.en_mdl_linklist__carousel--image',
		{
			wrapper: '.en_mdl_linklist__wrapper',
			scroller: '.en_mdl_linklist__wrapper-inner',
			inner: 'en_mdl_linklist__inner',
			items: '.en_list__item',
			controls: {
				root: '.en_mdl_linklist__controls',
				prev: '.en_mdl_linklist__prev',
				next: '.en_mdl_linklist__next',
			},
		},
		{
			controlsType: 'simple',
			centerControlsTo: '.en_list__item_inner > img'
		},
		scopeEl
	);
}

const initContentCarousel = function( scopeEl = document ) {
	initCarousel( '.mdl_carousel', {}, {}, scopeEl );
}

const initColorChoicesCarousel = function( scopeEl = document ) {
	initCarousel(
		'.en_mdl_article_detail__color_choices',
		{
			wrapper: '.en_mdl_article_detail__color_choices_wrapper',
			scroller: '.en_mdl_article_detail__color_choices_container',
			inner: '.en_mdl_article_detail__color_choices_inner',
			items: '.en_mdl_article_detail__color_choice',
			controls: {
				root: '.en_mdl_article_detail__color_choices-controls',
				prev: '.en_mdl_article_detail__color_choices-prev',
				next: '.en_mdl_article_detail__color_choices-next',
			},
			selectedItem: '.is_selected'
		},
		{
			controlsType: 'simple',
			scrollToSelected: true
		},
		scopeEl
	);
}

const initAn150MomentsCarousel = function( scopeEl = document ) {
	initCarousel(
		'.mdl_an150_moments__carousel',
		{
			wrapper: '.mdl_an150_moments__carousel-inner',
			scroller: '.mdl_an150_moments__carousel-list',
			inner: '.mdl_an150_moments__carousel-list_inner',
			items: '.mdl_an150_moments__carousel-item'
		},
		{

		},
		scopeEl
	);
};

const initAn150ShopcatCarousel = function( scopeEl = document ) {
	initCarousel(
		'.mdl_shopcatcarousel__carousel',
		{
			wrapper: '.mdl_shopcatcarousel__carousel-inner',
			scroller: '.mdl_shopcatcarousel__carousel-list',
			items: '.mdl_shopcatcarousel__carousel-item'
		},
		{

		},
		scopeEl
	);
}

const initThumbsCarousel = function( root ) {
	root.SL_ThumbsCarousel ??= new Carousel( root,
		{
			wrapper: '.en_mdl_article_detail__thumbs-slider-wrapper',
			scroller: '.en_mdl_article_detail__thumbs-slider-inner',
			inner: '.en_mdl_article_detail__thumbs-slider-items',
			items: '.en_mdl_article_detail__thumbs-slider-item',
			controls: {
				root: '.en_mdl_article_detail__thumbs-slider-controls',
				prev: '.en_mdl_article_detail__thumbs-slider-prev',
				next: '.en_mdl_article_detail__thumbs-slider-next',
			},
			selectedItem: '.active',
		},
		{
			controlsType: 'simple',
			orientationVertical: true,
		}
	);
	root.SL_ThumbsCarousel.reinitialize();
}

export {
	Carousel as default,
	initCarousel,
	initMainMenuCarousel,
	initProductCarousel,
	initBrandCarousel,
	initLinklistCarousel,
	initContentCarousel,
	initColorChoicesCarousel,
	initAn150ShopcatCarousel,
	initAn150MomentsCarousel,
	initThumbsCarousel
}
